// =============================================
// NÓ: END (FIM DO FLUXO) - MOBILE FIRST
// =============================================
// Arquivo: EndNode.tsx
// Descrição: Nó de fim do fluxo - otimizado para touch
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface EndNodeProps {
  data: {
    label?: string;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const EndNode: React.FC<EndNodeProps> = ({ data, selected }) => {
  return (
    <div className={`custom-node end-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="end-input"
        className="node-handle target-handle"
      />
      <div className="node-icon">
        <i className="fas fa-flag-checkered"></i>
      </div>
      <div className="node-content">
        <div className="node-label">{data.label || 'Fim'}</div>
        <ActionsBadge actions={data.actions} />
      </div>
    </div>
  );
};

export default EndNode;
